export default "/fonts/TiemposHeadline-Medium.eot?bde0660974a1b8b29024b7a83acec856";